(function () {
    var $window = $(window);
    var issueItem = {
        vPort: 'screen-sm',
        isMobile: false,
        $truncateCaptions: $('.truncate-captions'),
        seeMoreText: 'View all authors',
        seeLessText: 'View fewer authors',
        truncateOptions: {
            lines: 3,
            type: 'list',
            seeMoreLink: true,
            seeMoreIcon: 'icon-plus',
            seeLessIcon: 'icon-close',
            seeMoreIconMobile: 'icon-plus',
        },
        init() {
            issueItem.setCaptions();
            issueItem.controls();
            issueItem.truncate();
        },
        setCaptions() {
            if (issueItem.$truncateCaptions.length) {
                issueItem.seeMoreText = issueItem.$truncateCaptions.data('view-all-author');
                issueItem.seeLessText = issueItem.$truncateCaptions.data('view-fewer-author');
            }
        },
        truncate() {
            const {seeMoreText, seeLessText} = issueItem;
            $('.issue-item__authors .loa')
                .not("[data-truncate='none']")
                .truncate({
                    ...issueItem.truncateOptions,
                    seeLessText,
                    seeMoreText,
                });
        },
        controls() {
            $window.on('resized orientationchange', function () {
                $('.issue-item__authors .loa').not("[data-truncate='none']").truncate();
            });
        },
    };
    UX.issueItem = issueItem;
})();
